import { Injectable } from '@angular/core';
import { DealerSpecificServices } from '@core/enums';
import { isFuelTypeElectrical } from '@core/utils';

@Injectable({ providedIn: 'root' })
export class VehicleHelperService {

  /**
   * Checks if the current vehicle is a Mustang model.
   *
   * Performs a case-insensitive search for "Mustang" in the vehicle's model name.
   *
   * @returns `true` if the vehicle model name contains "Mustang", `false` otherwise
   *
   * @example
   * ```typescript
   * if (service.isMustangVehicle()) {
   *   console.log('This is a Mustang!');
   * }
   * ```
   */
  protected isMustangVehicleHelper(modelName: string): boolean {
    return modelName.toLowerCase().includes(DealerSpecificServices.mustang.toLowerCase());
  }

  /**
   * Checks if the current vehicle is electric (EV or PHEV).
   *
   * Uses the fuel type to determine if the vehicle is electric.
   * This includes fully electric vehicles (EV) and plug-in hybrid electric vehicles (PHEV).
   *
   * @returns `true` if the vehicle is electric, `false` otherwise
   *
   * @example
   * ```typescript
   * if (service.isElectricVehicle()) {
   *   console.log('This vehicle requires electric charging services');
   * }
   * ```
   */
  protected isElectricalVehicleHelper(fuelType: string): boolean {
    return isFuelTypeElectrical(fuelType);
  }
}
